import { GetStaticPropsResult } from 'next'

import { SanitySiteFragment } from '@data/sanity/queries/types/site'
import { SanityPasswordRecoveryPage } from '@data/sanity/queries/types/page'
import { getPreview } from '@lib/sanity/client'
import { getPasswordRecoveryPage } from '@lib/sanity/page'
import { Locale } from '@lib/language'
import { CustomStaticPropsContext } from '@lib/routes'

import Modules from '@modules/modules'
import Layout from '@components/layout'

interface PasswordRecoveryPageProps {
  locale: Locale
  page: SanityPasswordRecoveryPage
  site: SanitySiteFragment
}

const PasswordRecoveryPage = ({ page, site }: PasswordRecoveryPageProps) => (
  <Layout page={page} site={site}>
    <Modules modules={page.modules} />
  </Layout>
)

export async function getStaticProps({
  locale,
  preview,
  previewData,
}: CustomStaticPropsContext): Promise<
  GetStaticPropsResult<PasswordRecoveryPageProps>
> {
  const passwordRecoveryPage = await getPasswordRecoveryPage(
    locale,
    getPreview(preview, previewData)
  )

  if (!passwordRecoveryPage.page) {
    return { notFound: true }
  }

  return {
    props: {
      locale,
      page: passwordRecoveryPage.page,
      site: passwordRecoveryPage.site,
    },
    revalidate: 60,
  }
}

export default PasswordRecoveryPage
